<template>
  <a-tree-select
    style="width: 100%"
    treeNodeFilterProp="title"
    :dropdownStyle="{ maxHeight : '250px' }"
    :tree-data="actorOptions2"
    tree-checkable
    v-model="actor2"
    :show-checked-strategy="SHOW_PARENT"
    search-placeholder="Auswahl"/>
</template>
<script>
import axios from 'axios';
import { TreeSelect } from 'ant-design-vue';
import { url } from '../App.vue';

const { SHOW_PARENT } = TreeSelect;

export default {
  name: 'ActorFilter2',
  data() {
    return {
      SHOW_PARENT,
      tabs: [],
      visible: true,
      actorPuffer2: this.actorInput2,
      actorOptions2: [],
      size: 12,
      filterSize: 12,
    };
  },
  async mounted() {
    const accessToken = await this.$auth.getTokenSilently();
    const form = this.$store.state.filter;
    const db = this.$store.state.db;
    await axios.post(url + 'actor2/', {form, db},
        {headers: {authorization: `Bearer ${accessToken}`}})
      .then((response) => {
        this.actorOptions2 = response.data;
      }).catch();
  },
  props: {
    actorInput2: {
      required: true,
      type: Array,
    },
  },
  computed: {
    actor2: {
     get() {
        return this.actorPuffer2;
      },
      set(value) {
        this.$emit('update:actorInput2', value);
      },
    },
  },
  watch: {
    '$store.state.db': function () {
      this.getSelectOptionsActor2Name(true);
    },
    '$store.state.filter.country': function () {
      this.getSelectOptionsActor2Name(false);
    },
    '$store.state.filter.actor1': function () {
      this.getSelectOptionsActor2Name(false);
    },
    actorInput2: {
      deep: true,
      handler(value) {
        //const form = this.$store.state.filter;
        //const db = this.$store.state.db;
        this.actorPuffer2 = value;
        //axios.post(url + 'actor2/', {form, db})
        //.then((response) =>{
        //  this.staff = response.data;
        //  cookie.set('staff',{data: response.data});
        //});
      return;
      },
    },
  },
  methods: {
    async getSelectOptionsActor2Name(dbSwitch){
      if(dbSwitch) {
          this.$store.state.filter.actor1 = ["Alle"];
          this.$store.state.filter.actor2 = ["Alle"];
        }
        const accessToken = await this.$auth.getTokenSilently();
        const form = this.$store.state.filter;
        const db = this.$store.state.db;
        await axios.post(url + 'actor2/', {form, db},
            {headers: {authorization: `Bearer ${accessToken}`}})
        .then((response) => {
          this.actorOptions2 =  response.data;
          this.actorPuffer2 = ['Alle'];
          this.$emit('update:actorInput2', this.actorPuffer2);
        }).catch();
    }
  },
};
</script>
